import 'whatwg-fetch'
import getClosest from './ParentSelector'

export default () => {
  let forms = document.querySelectorAll('.js-form')
  const lang = document.querySelector('html').lang
  if (document.querySelectorAll('.js-steps-form-form').length > 0) {
    forms = document.querySelectorAll('.js-steps-form-form')
  }
  if (forms && lang === 'nl') {
    Array.from(forms).forEach((form) => {
      const nextButton = form.querySelector('.js-steps-form-next')
      const zipcode = form.querySelector('input[name="postal"]')
      const housenumber = form.querySelector('input[name="housenumber"]')
      const street = form.querySelector('input[name="streetname"]')
      const city = form.querySelector('input[name="city"]')
      const cityParent = getClosest(city, '.c-input')
      const streetParent = getClosest(street, '.c-input')
      const messageBox = form.querySelector('.js-message-box')
      let zipValue = ''
      let housenumberValue = ''
      if (zipcode && housenumber) {
        if (streetParent && cityParent) {
          street.classList.add('disabled')
          city.classList.add('disabled')
          streetParent.classList.add('disabled')
          cityParent.classList.add('disabled')
        }
        zipcode.addEventListener('blur', (e) => {
          zipValue = e.target.value.split(' ').join('')
          housenumberValue = housenumber.value
          if (zipValue !== '' && housenumberValue !== '') {
            getAddress(zipValue, housenumberValue, street, city, streetParent, cityParent, messageBox)
          }
        })
        housenumber.addEventListener('blur', (e) => {
          housenumberValue = e.target.value
          zipValue = zipcode.value.split(' ').join('')
          if (zipValue !== '' && housenumberValue !== '') {
            getAddress(zipValue, housenumberValue, street, city, streetParent, cityParent, messageBox)
          }
        })
        zipcode.addEventListener('touchstart', (e) => {
          document.body.addEventListener('touchstart', checkIfItsMe)
        })
        housenumber.addEventListener('touchstart', (e) => {
          document.body.addEventListener('touchstart', checkIfItsMe)
        })

        const checkIfItsMe = (e) => {
          if (!e.target.name) {
            const parent = getClosest(e.target, '.c-input')
            if (parent) {
              let input = parent.querySelector('input[name="postal"]')
              if (!input) {
                input = parent.querySelector('input[name="housenumber"]')
              }
              if (input !== zipcode && input !== street) {
                zipValue = zipcode.value.split(' ').join('')
                housenumberValue = housenumber.value
                if (zipcode.value !== '' && housenumber.value !== '') {
                  document.body.removeEventListener('touchstart', checkIfItsMe)
                  getAddress(zipValue, housenumberValue, street, city, streetParent, cityParent, messageBox)
                }
              }
            }
          }

          if (e.target !== zipcode && e.target !== street) {
            zipValue = zipcode.value.split(' ').join('')
            housenumberValue = housenumber.value
            if (zipcode.value !== '' && housenumber.value !== '') {
              document.body.removeEventListener('touchstart', checkIfItsMe)
              getAddress(zipValue, housenumberValue, street, city, streetParent, cityParent, messageBox)
            }
          }
        }
        zipcode.addEventListener('keydown', (e) => {
          if (e.keyCode === 9) {
            if (zipcode.value !== '' && housenumber.value !== '') {
              zipValue = e.target.value.split(' ').join('')
              if (city.classList.contains('disabled')) {
                e.preventDefault()
                getAddress(zipValue, housenumberValue, street, city, streetParent, cityParent, messageBox)
              }
            }
          }
        })
        housenumber.addEventListener('keydown', (e) => {
          if (e.keyCode === 9) {
            if (zipcode.value !== '' && housenumber.value !== '') {
              housenumberValue = e.target.value
              if (city.classList.contains('disabled')) {
                e.preventDefault()
                getAddress(zipValue, housenumberValue, street, city, streetParent, cityParent, messageBox)
              }
            }
          }
        })
        if (nextButton) {
          nextButton.addEventListener('click', (e) => {
            if (zipcode.value !== '' && housenumber.value !== '') {
              getAddress(zipValue, housenumberValue, street, city, streetParent, cityParent, messageBox)
            }
          })
        }
      }
    })
  }

  const getAddress = (zipcode, housenumber, street, city, streetParent, cityParent, messageBox) => {
    window
      .fetch(`https://api.postcodeapi.nu/v2/addresses/?postcode=${zipcode}&number=${housenumber}`, {
        method: 'get',
        headers: {
          'X-Api-Key': 'pKtNEqpgNj7lpfnUkifg7ntwEVm43zI7iYQfMlz6',
          accept: 'application/hal+json'
        }
      })
      .then((response) => {
        return response.json()
      })
      .then((r) => {
        // console.log(r)
        if (messageBox) {
          if (messageBox.classList.contains('error')) {
            messageBox.classList.remove('error')
          }
        }

        const data = r._embedded.addresses[0]
        if (messageBox) {
          messageBox.classList.add('active')
        }
        if (data.city.label !== '' && data.street !== '') {
          street.value = data.street
          city.value = data.city.label
          street.checkValidity()
          city.checkValidity()
        }
        if (!messageBox) {
          city.classList.remove('disabled')
          street.classList.remove('disabled')
          streetParent.classList.remove('disabled')
          cityParent.classList.remove('disabled')
        }
        let addition = data.addition !== null ? data.addition : ''
        if (messageBox) {
          messageBox.innerHTML =
            data.street + ' ' + data.number + addition + ', ' + data.postcode + ' ' + data.city.label
        }
      })
      .catch((e) => {
        if (messageBox) {
          messageBox.classList.add('error')
          messageBox.innerHTML = 'Error: Adres niet opgehaald, vul deze a.u.b. handmatig in'
          if (messageBox.classList.contains('active')) {
            messageBox.classList.remove('active')
          }
        }

        city.classList.remove('disabled')
        street.classList.remove('disabled')
        streetParent.classList.remove('disabled')
        cityParent.classList.remove('disabled')
      })
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/ZipcodeAPI.js